// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1--Fj","insightsList":"newBusinessInsightsMenu_insightsList__3Ht64","active":"newBusinessInsightsMenu_active__3hekn"};